import { render, staticRenderFns } from "./BlockTimeForm.vue?vue&type=template&id=704cc616&"
import script from "./BlockTimeForm.vue?vue&type=script&lang=js&"
export * from "./BlockTimeForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockTimeForm.vue?vue&type=style&index=0&id=704cc616&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports